import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { IntegrationSettings } from '../../models/integrations.model';

@Component({
    selector: 'app-integration-tab-container',
    templateUrl: './integration-tab-container.component.html',
    styleUrls: ['./integration-tab-container.component.scss']
})
export class IntegrationTabContainerComponent implements OnInit {
    @Input() integrationSettings: IntegrationSettings;

    selectedTab: string = 'details';
    selectedTabIndex: number = 0;

    constructor(
        public translate: TranslateService,
    ) {
    }

    ngOnInit(): void {
    }

    selectTab(tab: string) {
        this.selectedTab = tab;
    }

    get showMappingsTab(): boolean {
        return this.integrationSettings.integration.id !== 'Payzaar' && this.integrationSettings.integration.id !== 'IcimsInbound';
    }
}
